import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBaseQueryWithCamelize } from "../apiTools";
import {
  ILoginParams,
  IResetPasswordParams,
  IForgotPasswordParams,
  ILoginResponse,
} from "./types";

const baseQuery = getBaseQueryWithCamelize(
  fetchBaseQuery({
    baseUrl: `${window.config.REACT_APP_API_BASE_URL}authentication/`,
  })
);

export const ssoApi = createApi({
  reducerPath: "ssoApi",
  baseQuery,
  endpoints: (builder) => ({
    resetPassword: builder.mutation<unknown, IResetPasswordParams>({
      query: (data) => ({
        url: "v1/password-reset-confirm/",
        method: "POST",
        body: data,
      }),
    }),
    attemptLogin: builder.mutation<ILoginResponse, ILoginParams>({
      query: (data) => ({
        url: "v1/login/",
        method: "POST",
        body: data,
      }),
    }),
    submitEmail: builder.mutation<unknown, IForgotPasswordParams>({
      query: (data) => ({
        url: "v1/password-reset/",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useResetPasswordMutation,
  useAttemptLoginMutation,
  useSubmitEmailMutation,
} = ssoApi;
